module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "CN",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Also by Mike Lawson")])]), _vm._v(" "), _c('p', {
    staticClass: "AdCardTitle"
  }, [_vm._v("The Inside Ring")]), _vm._v(" "), _c('p', {
    staticClass: "AdCardTitle"
  }, [_vm._v("The Second Perimeter")]), _vm._v(" "), _c('p', {
    staticClass: "AdCardTitle"
  }, [_vm._v("House Rules")]), _vm._v(" "), _c('p', {
    staticClass: "AdCardTitle"
  }, [_vm._v("House Secrets")]), _vm._v(" "), _c('p', {
    staticClass: "AdCardTitle"
  }, [_vm._v("House Justice")]), _vm._v(" "), _c('p', {
    staticClass: "AdCardTitle"
  }, [_vm._v("House Divided")]), _vm._v(" "), _c('p', {
    staticClass: "AdCardTitle"
  }, [_vm._v("House Blood")]), _vm._v(" "), _c('p', {
    staticClass: "AdCardTitle"
  }, [_vm._v("House Odds")]), _vm._v(" "), _c('p', {
    staticClass: "AdCardTitle"
  }, [_vm._v("House Reckoning")]), _vm._v(" "), _c('p', {
    staticClass: "AdCardTitle"
  }, [_vm._v("Rosarito Beach")]), _vm._v(" "), _c('p', {
    staticClass: "AdCardTitle"
  }, [_vm._v("Viking Bay")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0218505b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eBook_4345-1.vue
// module id = 66
// module chunks = 0